export default {
  hello_world : 'Hello world',
  /*TournamentRegistrationForm*/
  tournament_registration_form_msg_1 : "Please complete information below.",
  tournament_registration_form_team_data : "Team Information",
  tournament_registration_form_team_name : "Team Name",
  tournament_registration_form_league_name : "Local League Name",
  tournament_registration_form_team_city : "Team City",
  tournament_registration_form_coach_data  : "Coach Information",
  tournament_registration_form_coach_name : "First Name",
  tournament_registration_form_coach_last_name : "Last Name",
  tournament_registration_form_coach_phone : "Phone",
  tournament_registration_form_coach_email : "Email",
  tournament_registration_form_coach_email_confirm : "Confirm Email",
  tournament_registration_form_coach_country : "Country",
  tournament_registration_form_coach_state : "State",
  tournament_registration_form_coach_postal_code : "Zip Code",
  tournament_registration_form_coach_social_data : "Social",
  tournament_registration_form_how_do_you_find : "How did you find out about Alianza?",
  tournament_registration_form_how_do_you_find_1 : "Facebook",
  tournament_registration_form_how_do_you_find_2 : "Twitter",
  tournament_registration_form_how_do_you_find_3 : "Instagram",
  tournament_registration_form_how_do_you_find_4 : "Website",
  tournament_registration_form_how_do_you_find_5 : "Family",
  tournament_registration_form_how_do_you_find_6 : "Coach",
  tournament_registration_form_how_do_you_find_7 : "Friend",
  tournament_registration_form_how_do_you_find_8 : "TV",
  tournament_registration_form_how_do_you_find_9 : "Newspaper",
  tournament_registration_form_how_do_you_find_10 : "Radio",
  tournament_registration_form_how_do_you_find_11 : "President of League",
  tournament_registration_form_how_do_you_find_12 : "Other",
  tournament_registration_form_send_btn : "Register team",
  tournament_registration_form_thanks : "Thank you, your registration has been successfully submitted. Please review your email for further details.",
  tournament_registration_form_confirmation_email_error : "The email and its confirmation do not match.",
  /*Alerts*/
  alerts_error_title : "An error has occurred",
  alerts_accept : "Accept"

}



// WEBPACK FOOTER //
// ./src/lang/en.js